<template>
    <!-- 课票订单-票券订单详情-操作记录 -->
    <!-- 用户票券管理-操作记录 -->
    <div>
        <content-view>
            <div class="wrap-container-in">
                <div class="text-right pb16">
                    <a-radio-group v-if="isGived" v-model="isOriginal" button-style="solid" @change="isOriginalChange">
                        <a-radio-button :value="0">
                            当前持有人
                        </a-radio-button>
                        <a-radio-button :value="1">
                            原持有人
                        </a-radio-button>
                    </a-radio-group>
                </div>
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                    <span slot="index" slot-scope="a, row, index">{{index + 1}}</span>
                    <!-- <span slot="operateTime" slot-scope="operateTime">{{operateTime && operateTime.substr(0,10)}}</span> -->
                    <span slot="amount" slot-scope="amount">{{amount ? amount : '0.00'}}</span>
                    <span slot="context" slot-scope="context">{{context || "-"}}</span>
                    <span slot="remarkCategoryName" slot-scope="remarkCategoryName">{{remarkCategoryName || "-"}}</span>
                    <span slot="remark" slot-scope="remark">{{remark || "-"}}</span>
                    <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
                </a-table>
            </div>
        </content-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "操作时间",
        dataIndex: "operateTime",
        scopedSlots: { customRender: "operateTime" }
    },
    {
        title: "操作动作",
        dataIndex: "operateName"
    },
    {
        title: "操作内容",
        dataIndex: "operateDetail",
        scopedSlots: { customRender: "operateDetail" }
    },
    // {
    //     title: "金额/元",
    //     dataIndex: "amount",
    //     scopedSlots: { customRender: "amount" }
    // },
    {
        title: "备注类型",
        dataIndex: "remarkCategoryName",
        scopedSlots: { customRender: "remarkCategoryName" },
    },
    {
        title: "备注",
        dataIndex: "remark",
        scopedSlots: { customRender: "remark" },
    },
    {
        title: "操作人",
        dataIndex: "operator",
        scopedSlots: { customRender: "operator" }
    }]
    export default {
        name: "operateRecord",
        components: {},
        props: {},
        data() {
            return {
                options: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                isOriginal: 0,
                isGived: false
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            // 获取基础票券详情
            getDetail() {
                this.$api.order
                    .detailUserTicket({
                        params: {userTicketNo: this.$route.query.userTicketId}
                    }).then(res => {
                        this.isGived = res.userTicketNo !== res.originalUserTicketNo;
                    });
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
            },

            // 获取列表
            getList() {
                this.$api.order
                .opRecord({
                    body: {
                        isOriginal: Boolean(this.isOriginal),
                        userTicketNo: this.$route.query.userTicketId,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                })
                .then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                });
            },
            /**
             * @isOriginalChange 是否当前持有人
             */
            isOriginalChange() {
                this.getList();
            },
        },
        created() {},
        mounted() {
            this.getDetail();
            this.getList();
        },
    };
</script>
<style lang="scss">
</style>
